import type { PowerSyncKyselyDatabase } from '@powersync/kysely-driver';
import type { Database } from '~/powersync/generated/schema';
import type { CompilableQuery } from '@powersync/react-native';

/**
 * Local database instance type (abstracted from PowerSync)
 */
export type LocalDatabase = PowerSyncKyselyDatabase<Database>;

/**
 * Query function that takes a database and returns a compilable query
 */
export type QueryFunction<T> = (db: LocalDatabase) => CompilableQuery<T>;

/**
 * Mutation function that takes a database and input, returns a promise
 */
export type MutationFunction<TInput, TOutput> = (
  db: LocalDatabase,
  input: TInput,
) => Promise<TOutput>;

/**
 * Simple mutation function that only takes a database
 */
export type SimpleMutationFunction<TOutput = void> = (
  db: LocalDatabase,
) => Promise<TOutput>;
